import initI18n from './i18n';

/**
 * Initializes the metric package (i18n).
 */
export default function init(): void {
  initI18n();
}
